import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'tngh-form-grid',
  standalone: true,
  templateUrl: './form-grid.component.html',
  styleUrls: ['./form-grid.component.scss'],
  imports: [CommonModule]
})
export class FormGridComponent {}
